import React from "react"
import AccountLayout from "@/components/AccountLayout"
import AccountsActivate from "../components/AccountsActivate"
import Message from "@/components/Message"
import { Alert, Heading, Text, Box } from "@chakra-ui/react"

export default function AccountsActivateView() {
  const [activated, setActivated] = React.useState(false)
  const [error, setError] = React.useState(null)

  const activate = (
    <AccountsActivate setActivated={setActivated} setError={setError} />
  )

  const message = (
    <Message>
      <Heading variant="standardSub">Welcome to Blind Insight!</Heading>
      <Text fontSize="1.5em">Account activation</Text>
      <Text>
        <strong>If you were responding to an Organization invitation:</strong>
      </Text>
      <Text>
        Please check your email for a link to set your initial password.
      </Text>
      <Text>
        <strong>If you self-registered:</strong>
      </Text>
      <Text>You chose a password during registration and are good to go!</Text>
      <Text fontSize="1.5em">Let&apos;s get you started!</Text>
      <Text>Please follow the link below to proceed to the app.</Text>
      <Box mt="1em">
        {!activated && <Text>Activating your account...</Text>}
        {activated && <Alert status="success">{activated}</Alert>}
        {error && <Alert status="error">{error}</Alert>}
      </Box>
    </Message>
  )

  return <AccountLayout gradientBox={activate} message={message} />
}
